<div id="blog-card">
  <mat-card appearance="outlined" class="p-0">
    <mat-card-content>
      <mat-card-title class="header" (click)="navigate()">
        <mat-icon>article</mat-icon>
        <strong>{{ post.actualName || post.name }}</strong>
      </mat-card-title>
      <p class="text" (click)="navigate()">
        {{ post.actualDescription || post.description }}
      </p>

      <div class="footer">
        <div class="footer-end d-flex">
          @if (createMode && isBlogAdmin) {
            <button mat-icon-button class="edit-button-hover" aria-label="Edit">
              <mat-icon>edit</mat-icon>
            </button>
            <ng-container *ngTemplateOutlet="cardMenu"></ng-container>
          }
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>

<ng-template #cardMenu>
  <mat-menu #appMenu="matMenu" yPosition="above" xPosition="before">
    <button mat-menu-item (click)="openDialog('set-blog-name', post._id)">
      {{ 'Blog.Overview.EditBlogName' | translate }}
    </button>
    <button mat-menu-item (click)="openDialog('set-blog-description', post._id)">
      {{ 'Blog.Overview.EditBlogDesc' | translate }}
    </button>
    @if (!post.isEncrypted) {
      <button mat-menu-item (click)="encryptContent(post.content_id)">
        {{ 'Global.EncryptContent' | translate }}
      </button>
    }
    @if (post.isEncrypted) {
      <button mat-menu-item (click)="decryptContent(post.content_id)">
        {{ 'Global.DecryptContent' | translate }}
      </button>
    }
    <button mat-menu-item (click)="openShareMenu(post._id)">
      {{ 'Global.Share' | translate }}
    </button>
    <button mat-menu-item (click)="archiveBlog(post._id)">
      {{ 'Global.Archive' | translate }}
    </button>
    <button mat-menu-item (click)="generateContentEmbedding(post.content_id)">
      {{ 'ChunkDisplayer.chunkOptions.GenerateEmbeddings' | translate }}
    </button>
    <button mat-menu-item (click)="deleteBlog(post._id, post.actualName || post.name)">
      {{ 'Global.Delete' | translate }}
    </button>
  </mat-menu>
  <button mat-icon-button [matMenuTriggerFor]="appMenu">
    <mat-icon>more_horiz</mat-icon>
  </button>
</ng-template>
